import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header d-flex align-items-center" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "table table-tenant-sm table-hover" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["onClick"]

import { ref, onMounted, inject } from "vue";
import {
  EventShopOrderStatusTypes,
  EventShopOrderStatusOptions,
} from "@/core/types/shop/ShopPointsTypes";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import EventsServices from "../services/EventsServices";
import OrderDetail from "../components/shop/OrderDetail.vue";
import AddTrackingModal from "../components/shop/AddTrackingModal.vue";
import TimeShow from "@/components/TimeShow.vue";
import { ElNotification } from "element-plus";
import i18n from "@/core/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopOrders',
  setup(__props) {

const t = i18n.global.t;
const isLoading = ref(false);
const data = ref(<any>[]);
const criteria = ref<any>({
  page: 1,
  pageSize: 25,
  status: EventShopOrderStatusTypes.Pending,
});

const reset = () => {
  criteria.value.email = null;
  fetchData(1);
};

const getStatusLabel = (value: number) => {
  const option = EventShopOrderStatusOptions.value.find(
    (option) => option.value === value
  );
  return option ? option.label : "";
};
const orderDetailRef = ref<any>(null);
const addTrackingModalRef = ref<any>(null);
const tab = ref(EventShopOrderStatusTypes.Pending);
const isTabActive = (_tab: any) => {
  return tab.value === _tab;
};
const accountSelected = ref(0);
const changeTab = (_value: any) => {
  tab.value = _value;
  criteria.value.status = tab.value;
  if (tab.value === 5) {
    criteria.value.status = null;
  }
  fetchData(1);
};

const showDetail = (item: any) => {
  orderDetailRef.value?.show(item);
};

const fetchData = async (page: number) => {
  isLoading.value = true;
  criteria.value.page = page;
  try {
    const res = await EventsServices.queryShopOrderList(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.error(error);
  }
  isLoading.value = false;
};

const openConfirmModal = inject<any>(
  TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL
);

const showAddTrackingModal = (item: any) => {
  addTrackingModalRef.value?.show(item);
};

const openConfirmPanel = (_action: EventShopOrderStatusTypes, id: number) => {
  openConfirmModal?.(() => {
    return {
      [EventShopOrderStatusTypes.Pending]: () =>
        EventsServices.pendingOrder(id),
      [EventShopOrderStatusTypes.Processing]: () =>
        EventsServices.processOrder(id),
      [EventShopOrderStatusTypes.Shipped]: () => EventsServices.shipOrder(id),
      [EventShopOrderStatusTypes.Succeed]: () =>
        EventsServices.succeedOrder(id),
      [EventShopOrderStatusTypes.Cancelled]: () =>
        EventsServices.cancelOrder(id),
    }
      [_action]()
      .then(() => {
        ElNotification({
          title: t("status.success"),
          message: t("status.success"),
          type: "success",
        });
        fetchData(criteria.value.page);
      });
  });
};

function getStatusTag(status: EventShopOrderStatusTypes) {
  switch (status) {
    case EventShopOrderStatusTypes.Pending:
      return "warning";
    case EventShopOrderStatusTypes.Processing:
      return "info";
    case EventShopOrderStatusTypes.Shipped:
      return "primary";
    case EventShopOrderStatusTypes.Succeed:
      return "success";
    case EventShopOrderStatusTypes.Cancelled:
      return "danger";
  }
}

function getButtonConfigs(item) {
  let configs: any[] = [];
  switch (item.status) {
    case EventShopOrderStatusTypes.Pending:
      configs.push(
        {
          label: "Process",
          type: "primary",
          action: () =>
            openConfirmPanel(EventShopOrderStatusTypes.Processing, item.id),
        },
        {
          label: "Cancel",
          type: "danger",
          action: () =>
            openConfirmPanel(EventShopOrderStatusTypes.Cancelled, item.id),
        }
      );
      break;

    case EventShopOrderStatusTypes.Processing:
      configs.push(
        {
          label: "Ship",
          type: "warning",
          action: () => showAddTrackingModal(item),
        },
        {
          label: "Cancel",
          type: "danger",
          action: () =>
            openConfirmPanel(EventShopOrderStatusTypes.Cancelled, item.id),
        }
      );
      break;

    case EventShopOrderStatusTypes.Shipped:
      configs.push(
        {
          label: "Succeed",
          type: "success",
          action: () =>
            openConfirmPanel(EventShopOrderStatusTypes.Succeed, item.id),
        },
        {
          label: "Cancel",
          type: "danger",
          action: () =>
            openConfirmPanel(EventShopOrderStatusTypes.Cancelled, item.id),
        }
      );
      break;

    case EventShopOrderStatusTypes.Succeed:
      configs.push({
        label: "Cancel",
        type: "danger",
        action: () =>
          openConfirmPanel(EventShopOrderStatusTypes.Cancelled, item.id),
      });
      break;

    case EventShopOrderStatusTypes.Cancelled:
      configs.push(
        {
          label: "Process",
          type: "primary",
          action: () =>
            openConfirmPanel(EventShopOrderStatusTypes.Processing, item.id),
        },
        {
          label: "Pending",
          type: "info",
          action: () =>
            openConfirmPanel(EventShopOrderStatusTypes.Pending, item.id),
        }
      );
      break;
  }
  return configs;
}

const selectedAccount = (id: number) => {
  accountSelected.value = id;
};
onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_ShopPoints = _resolveComponent("ShopPoints")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EventShopOrderStatusOptions), (tab) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "nav-item",
          key: tab.value
        }, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-2", [
          { active: isTabActive(tab.value) },
          { 'disabled opacity-50 pe-none': isLoading.value },
        ]]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: ($event: any) => (changeTab(tab.value))
          }, _toDisplayString(tab.label), 11, _hoisted_2)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_input, {
            class: "w-200px",
            modelValue: criteria.value.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.email) = $event)),
            clearable: "",
            placeholder: _ctx.$t('title.email'),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchData(1))),
            loading: isLoading.value,
            class: "ms-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_el_button, {
            onClick: reset,
            class: "ms-2",
            disabled: isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.user")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.itemName")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.totalPoints")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.operator")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id,
                      class: _normalizeClass({
              'tr-select': item.id === accountSelected.value,
            }),
                      onClick: ($event: any) => (selectedAccount(item.id))
                    }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_UserInfo, {
                          email: item.eventPartyEmail,
                          name: item.eventPartyNativeName,
                          class: "me-2"
                        }, null, 8, ["email", "name"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_tag, {
                          type: getStatusTag(item.status)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getStatusLabel(item.status)), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.eventShopItemName), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_ShopPoints, {
                          points: item.totalPoint
                        }, null, 8, ["points"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.operatorName), 1),
                      _createElementVNode("td", null, [
                        _createVNode(TimeShow, {
                          "date-iso-string": item.createdOn,
                          type: "GMToneLiner"
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          onClick: ($event: any) => (showDetail(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.detail")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getButtonConfigs(item), (button, index) => {
                          return (_openBlock(), _createBlock(_component_el_button, {
                            key: index,
                            type: button.type,
                            size: "small",
                            onClick: button.action
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(button.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["type", "onClick"]))
                        }), 128))
                      ])
                    ], 10, _hoisted_11))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(OrderDetail, {
      ref_key: "orderDetailRef",
      ref: orderDetailRef
    }, null, 512),
    _createVNode(AddTrackingModal, {
      ref_key: "addTrackingModalRef",
      ref: addTrackingModalRef,
      onFetchData: fetchData
    }, null, 512)
  ], 64))
}
}

})